import script from "./OneCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./OneCategory.vue?vue&type=script&setup=true&lang=js"

import "./OneCategory.vue?vue&type=style&index=0&id=4617b7de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4617b7de"]])

export default __exports__